import { useExperimentIsVariant } from "./useExperimentIsVariant";
import { useExperiments } from "./useExperiments";

export const useCorpBusinessTabsEnabled = (): boolean =>
  useExperimentIsVariant("corp-business-tabs", "available");

export const useCorpBusinessTabsState = () => {
  const { experimentsCallState } = useExperiments();

  return {
    enabled: useCorpBusinessTabsEnabled(),
    isResolved: experimentsCallState === "resolved",
  };
};
